import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { motion } from 'framer-motion';
import { Wine, MapPin, Calendar, Users } from 'lucide-react';
export function Wineries() {
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} transition={{
    duration: 0.5
  }} className="min-h-screen bg-white" data-id="element-609">
      <Header data-id="element-610" />

      <main className="pt-32 pb-24" data-id="element-611">
        {/* Hero Section */}
        <section className="max-w-7xl mx-auto px-6 mb-32 text-center" data-id="element-612">
          <span className="section-overline" data-id="element-613">Partnerships</span>
          <h1 className="text-[#4A0E0E] mb-8" data-id="element-614">Prestigious Estates</h1>
          <p className="text-[#2C2C2C]/60 max-w-3xl mx-auto text-lg" data-id="element-615">
            Cork Dorx partners with the valley's most exclusive wineries to
            provide our members with unparalleled access to private cellars,
            limited releases, and intimate tasting experiences.
          </p>
        </section>

        {/* Image Grid */}
        <section className="max-w-7xl mx-auto px-6 mb-32" data-id="element-616">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 h-[600px]" data-id="element-617">
            <div className="rounded-3xl overflow-hidden" data-id="element-618">
              <img src="https://cdn.magicpatterns.com/uploads/2nsRKWkqPRdLsMSFkk8CnB/pexels-polina-kovaleva-7270303.jpg" alt="Winery Estate" className="w-full h-full object-cover" data-id="element-619" />
            </div>
            <div className="grid grid-rows-2 gap-12" data-id="element-620">
              <div className="rounded-3xl overflow-hidden" data-id="element-621">
                <img src="https://images.unsplash.com/photo-1516594915697-87eb3b1c14ea?auto=format&fit=crop&q=80&w=800" alt="Vineyard" className="w-full h-full object-cover" data-id="element-622" />
              </div>
              <div className="bg-[#FDFCF0] rounded-3xl p-12 flex flex-col justify-center" data-id="element-623">
                <h2 className="text-3xl font-serif text-[#4A0E0E] mb-6" data-id="element-624">
                  Curated Selection
                </h2>
                <p className="text-[#2C2C2C]/70 leading-relaxed" data-id="element-625">
                  Every estate in our portfolio is hand-selected for its
                  commitment to excellence, sustainable practices, and unique
                  contribution to the region's viticultural heritage.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Partnership Benefits */}
        <section className="bg-[#4A0E0E] text-white py-32 px-6" data-id="element-626">
          <div className="max-w-7xl mx-auto" data-id="element-627">
            <div className="text-center mb-20" data-id="element-628">
              <h2 className="text-4xl font-serif mb-6" data-id="element-629">Member Benefits</h2>
              <p className="text-white/60" data-id="element-630">
                Exclusive advantages at our partner estates.
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-4 gap-12" data-id="element-631">
              {[{
              icon: <Wine size={32} data-id="element-632" />,
              title: 'Private Tastings',
              desc: 'Access to member-only tasting rooms and private cellar tours.'
            }, {
              icon: <Calendar size={32} data-id="element-633" />,
              title: 'Priority Booking',
              desc: 'Guaranteed reservations during peak season and harvest events.'
            }, {
              icon: <Users size={32} data-id="element-634" />,
              title: 'Vintner Access',
              desc: 'Meet the winemakers and gain insight into their craft.'
            }, {
              icon: <MapPin size={32} data-id="element-635" />,
              title: 'Estate Access',
              desc: 'Exclusive entry to grounds and facilities closed to the public.'
            }].map((benefit, idx) => <div key={idx} className="text-center" data-id="element-636">
                  <div className="text-[#D4AF37] mb-6 flex justify-center" data-id="element-637">
                    {benefit.icon}
                  </div>
                  <h4 className="text-xl font-serif mb-4" data-id="element-638">{benefit.title}</h4>
                  <p className="text-white/60 text-sm leading-relaxed" data-id="element-639">
                    {benefit.desc}
                  </p>
                </div>)}
            </div>
          </div>
        </section>
      </main>

      <Footer data-id="element-640" />
    </motion.div>;
}